﻿window.cBuilderEmailWidgetBouton = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetbouton'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Bouton</div>").appendTo($DivBt)
        $DivBt.attr("title","Ajouter un bouton cliquable")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetbouton'>")
        $("<!-- DEBUT BOUTON -->").appendTo(option.element)
        var $Td = $("<td style='width:100%;' width='100%' class='tdwidget bodywidget widgetheightauto'>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablewidget'>").appendTo($Td)

        var $TrTableBt = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:35%' class='tdleft'></td>").appendTo($TrTableBt)
        var $Td = $("<td style='width:30%' class='tdcenter'></td>").appendTo($TrTableBt)
        var $A = $("<a href='' target='_blank' class='bouton_a'/>").appendTo($Td)
        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablebt'>").appendTo($A)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='word-break:break-word;width:100%;' class='txtsaisie'></td>").appendTo($Tr)
        var $Td = $("<td style='width:35%' class='tdright'></td>").appendTo($TrTableBt)
        $("<!-- FIN BOUTON -->").appendTo(option.element)
    }

    function mGetLink() { return $(option.element.find("a")[0]) }
    function mGetTdLeft() { return $(option.element.find(".tdleft")[0]) }
    function mGetTdCenter() { return $(option.element.find(".tdcenter")[0]) }
    function mGetTdRight() { return $(option.element.find(".tdright")[0]) }
    function mGetTdSaisie() { return $(option.element.find(".txtsaisie")[0]) }

    this.nom = "Bouton"
    this.icone = "fas fa-stop"

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Texte bouton:</td>").appendTo(contentElement)
        var oldTxt = mGetTdSaisie().text()
        $("<div/>").appendTo(contentElement).dxCtrlTxtEmoji({
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: oldTxt,
            placeholder: "Texte du bouton...",
            onValueChanged: function (value) {
                mGetTdSaisie().text(value)
                option.onValueChanged()
            },
            onLoad: function () {
            }
        }).dxCtrlTxtEmoji("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Lien:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailSaisieLink({
            bddCtrl: option.bddCtrl,
            value: mGetLink().attr("href"),
            title: mGetLink().attr("title") || "",
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            lstfileheberge: option.dxBuilderEmailPage.option("lstfileheberge"),
            onValueChanged: function (link) {
                mGetLink().attr("href", link.link)
                mGetLink().attr("title", (link.title ? link.title : ""))
                switch (link.typeLink) {
                    case "Aucun":
                        mGetLink().css("pointer-events", "none")
                        break;
                    default:
                        mGetLink().css("pointer-events", "")
                        if (link.link.length == 0) mGetLink().css("pointer-events", "none")
                        break;
                }
                option.onValueChanged()
            }
        })
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleButton({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton_a")) {
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                mGetLink().css(prop, jsonCssData[prop])
            } else {
                mGetLink().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton", prop))
            }
        }
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton")) {
            if (prop == "width") {
                var widthPercent = 0
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    widthPercent = jsonCssData[prop].replace("%", "")
                } else {
                    widthPercent = option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton", prop).replace("%", "")
                }
                var rest = 100 - widthPercent
                mGetTdCenter().attr("width", widthPercent + "%")
                mGetTdCenter().css("width", widthPercent + "%")
                switch (option.parent.mGetTextAlignCss()) {
                    case "left":
                        mGetTdLeft().attr("width", "0")
                        mGetTdLeft().css("width", "0px")
                        mGetTdRight().attr("width", rest + "%")
                        mGetTdRight().css("width", rest + "%")
                        break;
                    case "center":
                        var restDiv2 = rest / 2
                        mGetTdLeft().attr("width", restDiv2 + "%")
                        mGetTdLeft().css("width", restDiv2 + "%")
                        mGetTdRight().attr("width", restDiv2 + "%")
                        mGetTdRight().css("width", restDiv2 + "%")
                        break;
                    case "right":
                        mGetTdLeft().attr("width", rest + "%")
                        mGetTdLeft().css("width", rest + "%")
                        mGetTdRight().attr("width", "0")
                        mGetTdRight().css("width", "0px")
                        break;
                }
            } else {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    mGetTdSaisie().css(prop, jsonCssData[prop])
                } else {
                    mGetTdSaisie().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("bouton", prop))
                }
            }
        }
    }

}